import React from 'react';
import { useEffect, useState, useRef } from 'react';
import LoadingPage from "../components/Loading";
import { useParams } from 'react-router-dom';
import { fetchRegistrationFormTemplateById } from '../services/registrationFormTemplates.js';
import {insertRegistrationForm} from '../services/registrationForms.js'
import { uploadCV } from '../services/documents.js';

const Form = ({scrollRef, handleSetRightNav}) => {
    const {id:templateId} = useParams();
    const [data, setData] = useState({});
    const [isloading, setisloading] = useState(false);
    const [isInitialized, setisInitialized] = useState(false);

    async function fetchDate(){
        setisloading(true)
        let result = await fetchRegistrationFormTemplateById(templateId);
        if(result?.result){
            setData(result.result);
            setisInitialized(true);
        }else{
            setData({});
            alert('無法獲取報名表資料，請稍後再試。')
        }
        setisloading(false)
    }
    useEffect(()=>{
        if(templateId.length===24){
            fetchDate()
        }
    },[templateId])

    const [isShowSuccessfulPage, setisShowSuccessfulPage] = useState(false)

    const handleSubmit = async () => {
        for(let i=0;i<(data?.questions||[]).length;i++){
            let q = data?.questions[i]
            if(q?.isRequired && (!q?.answer || q?.answer.length===0)){
                alert(`請回答必答問題: ${q?.question||''}`)
                return
            }
            if(q.type==='電子郵件' && q?.answer && q?.answer.length>0){
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if(!emailRegex.test(q.answer)){
                    alert(`請輸入正確的電郵地址: ${q?.question||''}`)
                    return
                }
            }
        }
        let json={
            templateId,
            questions: data?.questions||[],
            email: (data?.questions||[]).find(q=>q.type==='電子郵件')?.answer?.trim()?.toLowerCase()||'',
        }
        setisloading(true)
        let result = await insertRegistrationForm(json)
        setisloading(false)
        if(result?.errno===0){
            setisShowSuccessfulPage(true)
        }else{
            alert(result?.message||'提交失敗，請稍後再試。')
        }
    }

     const onUploadCV = (q,qi)=>async (e) => {
            let files = e.target.files;
            if (files.length === 0) {
                alert('請選擇一個文件');
                return;
            }
            if (files.length > 1) {
                alert('只能上傳一個文件');
                return;
            }
            const file = files[0]
            if (!['application/pdf', 'image/png', 'image/jpeg'].includes(file.type)) {
                alert(`文件類型 ${file.type} 不被允許`);
                return;
            }
    
            if (file.size > 1024 * 1024 * 5) {
                alert('文件大小不能超過5MB');
                return
            }
            setisloading(true);
            let formData = new FormData();
            formData.append('file', file, file.name);
            formData.append('json', JSON.stringify({}));
    
            let res = await uploadCV(formData, 'cv', `cv_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}`);
            setisloading(false);
            if (res.errno) {
                alert(res.message || '上傳失敗')
            } else {
                if (res.result) {
                    let filepath = res.result
                    let questions = data?.questions || []
                    questions[qi].answer = filepath
                    setData({...data, questions})
                }
            }
        }

    useEffect(() => {
        console.log(data)
    }, [data])

    if (!isInitialized) {
        return <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
            <div className="text-[24px] font-[700] text-[#6E604C]">加載中...</div>
            <div className="text-[16px] font-[400] text-[#6E604C]">Loading...</div>
        </div>
    }

    if (data.status !== 'published') {
        return (
            <div className="w-full h-full flex flex-col items-center justify-center min-h-[80vh]" style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                <div className="text-[24px] font-[700] text-[#6E604C]">報名尚未開始/已結束</div>
                <div className="text-[16px] font-[400] text-[#6E604C]">Registration has not started / already ended</div>
                <div className="text-[16px] font-[400] text-[#6E604C]">如有任何查詢，請聯絡我們</div>
                <div className="text-[16px] font-[400] text-[#6E604C]">
                    If you have any questions, please contact our admin.
                </div>
            </div>
        )
    }

    if (isShowSuccessfulPage) return (
        <div className="w-full h-full flex flex-col items-center justify-start p-[16px] bg-[#ddd]" style={{ overflowY: 'auto' }}>

            <div className="relative w-full max-w-[1300px]">
                <div className="relative w-full border-white border-2 p-[24px] rounded-[50px] flex flex-col justify-start items-center mt-[64px] overflow-hidden">
                    <div className='absolute bottom-0 w-full h-full' style={{ background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 69%, rgba(255, 255, 255, 0.6) 87.5%, #FFFFFF 100%)', zIndex: 1, }} />
                    <div className="flex flex-col w-full items-center gap-[16px] text-center" style={{ zIndex: 2 }}>

                        <div className="font-[400] d-text-28-m-22 text-[#6E604C]">
                            感謝你的登記！ 
                            {/* 以下是你的登記資料 */}
                        </div>
                        {/* <div className="font-[400] text-[18px] text-[#6E604C] mt-[12px]">
                            電郵地址 &nbsp;&nbsp; {data?.questions?.find(q=>q.type==='電子郵件')?.answer||'-'}
                        </div> */}
                        <div className="font-[350] d-text-28-m-22 text-[#6E604C] mt-[12px]">
                            您已登記成功，我們正在確認您的信息，工作人員會盡快與您聯繫
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <div className='w-full flex-col items-center relative'>
            <div className='grey-bg w-full flex flex-col items-center relative p-[24px]' style={{ backgroundImage: `url(/newlanding/img/home/bg_grain.png)`, zIndex: 2, backgroundSize: 'cover' }}>
                <div className='text-[#6E604C] font-[700] d-text-28-m-22 text-center mb-[16px]'>{data?.name || '報名表'}</div>
                {data?.questions?.map((q, qi) =>
                    <div key={qi} className='w-full max-w-[600px] bg-[white] rounded-[12px] p-[16px] mb-[16px] flex flex-col'>
                        <div className='text-[#6E604C] font-[600] text-[18px]'>{q?.question || ''}{q?.isRequired && <span className='text-[#E74C3C]'>*</span>}</div>
                        {q.hint?<div className='text-[#6E604Ca0] font-[400] text-[12px]'>{q?.hint || ''}</div>:<></>}
                        {/*'文字問題', '單選題', '電子郵件'*/}
                        {q.type === '文字問題' &&
                            <input type='text' className='mt-[8px] border border-[#ccc] rounded-[6px] p-[8px]' placeholder='請輸入文字' onChange={(e)=>{
                                let questions = data?.questions || []
                                questions[qi].answer = e.target.value
                                setData({...data, questions})
                            }}/>
                        }
                        {q.type === '電子郵件' &&
                            <input type='email' className='mt-[8px] border border-[#ccc] rounded-[6px] p-[8px]' placeholder='請輸入電郵地址' onChange={
                                (e)=>{
                                    let questions = data?.questions || []
                                    questions[qi].answer = e.target.value
                                    setData({...data, questions})
                                }
                            }/>
                        }
                         {q.type === '上傳履歷表' && <div className='flex flex-col mt-[8px]' style={{ gap: 8 }}>
                            <div className="d-flex2-m-100 flex flex-col items-start gap-[8px] py-[8px]" style={{ borderBottom: '1px solid #00000033' }}>
                               
                                <div className="flex flex-row w-full gap-[24px]">
                                    <input type="file" onChange={onUploadCV(q, qi)} className="flex-1 bg-[transparent] border-none rounded-[0px]" placeholder="請選擇檔案" />
                                </div>
                            </div>
                        </div>}
                        {q.type === '單選題' &&
                            <div className='flex flex-col mt-[8px]' style={{ gap: 8 }}>
                                {q?.options?.length > 0 ? q?.options?.map((option, oi) =>
                                    option==='其他'?
                                    <div key={oi} className='flex flex-row items-center gap-[8px]'>
                                        <input type='radio' name={`question-${qi}`} value={option} onChange={
                                            (e)=>{
                                                let questions = data?.questions || []
                                                questions[qi].answer = e.target.value
                                                setData({...data, questions})
                                            }
                                        } />
                                        <span className='text-[#6E604C]'>{option}</span>
                                        {q?.answer?.includes('其他')&&
                                        <input type='text' className='border border-[#ccc] rounded-[6px] p-[4px]' placeholder='請輸入其他內容' onChange={
                                            (e)=>{
                                                let questions = data?.questions || []
                                                questions[qi].answer = `其他: ${e.target.value}`
                                                setData({...data, questions})
                                            }
                                        }/>}
                                    </div>
                                    :
                                    <label key={oi} className='flex flex-row items-center gap-[8px]'>
                                        <input type='radio' name={`question-${qi}`} checked={data?.questions?.[qi]?.answer === option} onClick={
                                            (e)=>{
                                                let questions = data?.questions || []
                                                questions[qi].answer = questions[qi].answer===option ? '' : option
                                                setData({...data, questions})
                                            }
                                        } />
                                        <span className='text-[#6E604C]'>{option}</span>
                                    </label>
                                ) : <div className='text-[#E74C3C]'>此題無選項，請聯絡我們。</div>}
                            </div>
                        }
                        {q.type === '多選題' &&
                            <div className='flex flex-col mt-[8px]' style={{ gap: 8 }}>
                                {q?.options?.length > 0 ? q?.options?.map((option, oi) =>
                                    <label key={oi} className='flex flex-row items-center gap-[8px]'>
                                        <input type='checkbox' name={`question-${qi}`} value={option} onChange={
                                            (e)=>{
                                                let questions = data?.questions || []
                                                let selectedOptions = questions[qi].answer || []
                                                if(e.target.checked){
                                                    selectedOptions.push(option)
                                                }else{
                                                    selectedOptions = selectedOptions.filter(o=>o!==option)
                                                }
                                                questions[qi].answer = selectedOptions
                                                setData({...data, questions})
                                            }
                                        } />
                                        <span className='text-[#6E604C]'>{option}</span>
                                    </label>
                                ) : <div className='text-[#E74C3C]'>此題無選項，請聯絡我們。</div>}
                            </div>
                        }
                    </div>
                )}
                <div className='w-full max-w-[600px] flex flex-col items-center'>
                    <button onClick={handleSubmit} className='bg-[#681F0B] text-[white] font-[600] rounded-[24px] px-[32px] py-[12px]'>提交</button>
                </div>
                <div className='w-full h-[300px]'/>
            </div>
            {isloading && <LoadingPage />} 
            
        </div>
    )

};

export default Form;